<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication">To Adrienne, once more</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// theviennamelody_00000.vue?12096b03